import React, { useContext as useContextCore } from 'react'
import { type UseListResult } from '@ztechapps/common.hook'
import merge from 'lodash/merge'
import { components as userConversationComponents } from './components'
import type { ChatMessage } from '@ztechapps/common.contract'
import { useChatMessageSubscription, useRecentChatMessageList } from '@ztechapps/chat.common'
import type { Components } from './index'

export type ContextProps = {
  children?: React.ReactNode
  routesDef?: any
  components: Components
  height?: number | string
}

export type ContextType = {
  selectedChatMessage: ChatMessage
  setSelectedChatMessage: React.Dispatch<React.SetStateAction<ChatMessage>>
} & UseListResult<ChatMessage> &
  Omit<ContextProps, 'children'>

const context = React.createContext<ContextType>(null)
const CoreProvider = context.Provider

export const RecentMessageProvider = ({ components, children, ...props }: ContextProps) => {
  const chatGetRecentResult = useRecentChatMessageList()
  useChatMessageSubscription({
    onData: () => {
      //we trigger the refetch everytime there is an update
      chatGetRecentResult.refetch()
    },
  })

  const [selectedChatMessage, setSelectedChatMessage] = React.useState<ChatMessage>()
  //always merge the components
  const newComponents = merge({}, userConversationComponents, components)

  return (
    <CoreProvider
      value={{
        ...props,
        components: newComponents,
        ...chatGetRecentResult,
        selectedChatMessage,
        setSelectedChatMessage,
      }}
    >
      {children}
    </CoreProvider>
  )
}

export const useRecentMessageContext = () => useContextCore(context)
